<!--
 * @Description: 可配置20，或者调研5的pdf报告
 * @Date: 2024-07-18 15:28:33
-->
<template>
  <el-dialog
    title="提示"
    :destroy-on-close="true"
    :visible.sync="dialogVisible"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :center="true"
    width="400px"
  >
    <span>
      下载内容包含当期数据报表图片版，请确认以下基础信息的显示:
    </span>
    <div class="dialog-content">
      <el-checkbox v-model="checkboxObj.projectPeopleFlag">
        项目执行人
      </el-checkbox>
      <el-checkbox v-model="checkboxObj.phoneFlag">手机号</el-checkbox>
      <el-checkbox
        v-model="checkboxObj.taskSubmitTimeFlag"
        v-if="projectType == 20"
      >
        任务提交时间
      </el-checkbox>
    </div>
    <span slot="footer">
      <div class="footer-dialog">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">
          确 定
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { biBase } from '@/api/ajax.js';
export default {
  components: {},
  props: {
    projectType: Number,
    fenPeiId: Number
  },

  data() {
    return {
      dialogVisible: true,
      checkboxObj: {
        projectPeopleFlag: 1,
        phoneFlag: 1,
        taskSubmitTimeFlag: 1
      }
    };
  },
  watch: {},
  methods: {
    close() {
      this.dialogVisible = false;
    },
    cancel() {
      this.$emit('cancel');
      this.close();
    },
    confirm() {
      if (this.projectType == 5) {
        delete this.checkboxObj.taskSubmitTimeFlag;
      }
      this.$emit('sendData', this.dataConversion(this.checkboxObj, false));
    },
    dataConversion(data, isBoolean) {
      if ([undefined, null, ''].includes(isBoolean)) {
        return;
      }
      for (let key in data) {
        if (isBoolean) {
          data[key] = data[key] == 1 ? true : false;
        } else {
          data[key] = data[key] == true ? 1 : 0;
        }
      }
      return data;
    }
  },
  created() {
    biBase
      .queryImgLastBaseInfo({ type: 1, fenPeiId: this.fenPeiId })
      .then(res => {
        if (Object.keys(res.data.data).length === 0) {
          this.checkboxObj = this.dataConversion(this.checkboxObj, true);
        } else {
          this.checkboxObj = this.dataConversion(res.data.data, true);
        }
      });
    if (this.projectType == 5) {
      delete this.checkboxObj.taskSubmitTimeFlag;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.dialog-content {
  margin-top: 20px;
}
</style>
